import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// @mui
import { Container, Stack, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
// components
import { ProductSort, ProductList, ProductCartWidget, ProductFilterSidebar } from '../sections/@dashboard/products';
import { createProduct, fetchProducts, deleteProduct } from '../sections/@dashboard/products/productsSlice';
// import { fetchCategory } from '../features/Category/category.slices';
import { CreateProductModal } from '../sections/@dashboard/products/CreateProductModal';
import { showSnackbar } from '../features/Snackbar/snackbar.slice';
// ----------------------------------------------------------------------
export default function ProductsPage() {
  const [openFilter, setOpenFilter] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const dispatch = useDispatch();
  const products = useSelector((state) => state.products.products);
  const loading = useSelector((state) => state.products.loading);
  const error = useSelector((state) => state.products.error);

  const [productData, setProductData] = useState({
    name: '',
    description: '',
    media: '',
    category: 'trading',
  });
  const [selectedImage, setSelectedImage] = useState(null);

  const handleDeleteClick = async (id) => {
    try {
      console.log('deleted successfully', id);
      const pro = await dispatch(deleteProduct(id));
      console.log('pro', pro);
      // Nihad any options
      dispatch(fetchProducts());
      dispatch(showSnackbar({ message: 'Product Deleted ', status: 'success' }));
      // Handle success, show a success message, update the state, etc.
      console.log('Product deleted successfully');
    } catch (error) {
      // Handle errors, show an error message, etc.
      dispatch(showSnackbar({ message: 'Product Error ', status: 'error' }));
      console.error('Error deleting product:', error);
    }
  };

  const handleOpenFilter = () => {
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  useEffect(() => {
    dispatch(fetchProducts());
    // dispatch(fetchCategory());
  }, [dispatch]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(productData);
    handleCloseDialog();
  };

  const handleChange = (e) => {
    console.log('datas', e.target.value);
    setProductData({
      ...productData,
      [e.target.name]: e.target.value,
    });
    console.log('field', productData);
  };

  const handleImageChange = (e) => {
    console.log('file', e);
    setProductData({
      ...productData,
      media: e.target.files[0],
    });
    const imageUrl = URL.createObjectURL(e.target.files[0]);
    setSelectedImage(imageUrl);
  };

  const handleCreateProduct = async (e) => {
    e.preventDefault();
    console.log('datas', productData);
    if (productData.media !== '') {
      dispatch(createProduct(productData))
        .then(() => {
          dispatch(showSnackbar({ message: 'Product Successfully Added ', status: 'success' }));
          setProductData({
            name: '',
            description: '',
            media: '',
            category: 'manufacturing',
          });
          setSelectedImage(null);
          handleCloseDialog();
        })
        .catch((error) => {
          dispatch(showSnackbar({ message: 'Product Error', status: 'error' }));
        });
      // console.log('dispatch createProduct');
    } else {
      dispatch(showSnackbar({ message: 'Image Required', status: 'error' }));
    }
    // await
  };

  return (
    <>
      <Helmet>
        <title> Dashboard: Products</title>
      </Helmet>

      <Container>
        <Typography variant="h4" sx={{ mb: 5 }}>
          Products
        </Typography>

        <Stack direction="row" flexWrap="wrap-reverse" alignItems="center" justifyContent="flex-end" sx={{ mb: 5 }}>
          <Stack direction="row" spacing={1} flexShrink={0} sx={{ my: 1 }}>
            <Button variant="contained" color="primary" onClick={handleOpenDialog}>
              Add Product
            </Button>
            {/* <ProductFilterSidebar
              openFilter={openFilter}
              onOpenFilter={handleOpenFilter}
              onCloseFilter={handleCloseFilter}
            />
            <ProductSort /> */}
          </Stack>
        </Stack>

        <ProductList products={products} handleDeleteClick={handleDeleteClick} />
        {/* <ProductCartWidget /> */}
      </Container>
      <CreateProductModal
        openDialog={openDialog}
        handleCloseDialog={handleCloseDialog}
        handleSubmit={handleSubmit}
        productData={productData}
        handleChange={handleChange}
        loading={loading}
        handleImageChange={handleImageChange}
        setProductData={setProductData}
        handleCreateProduct={handleCreateProduct}
        selectedImage={selectedImage}
      />
    </>
  );
}
